module.exports = __webpack_public_path__ + "img/logo.36e75d7b.png";